import { MutationTree } from 'vuex';
import { AuthState } from './types';

export const mutations: MutationTree<AuthState> = {
    authRequest: (state) => {
        state.status = 'loading'
    },
    authSuccess: (state, token) => {
        state.status = 'success';
        state.token = token
    },
    authError: (state) => {
        state.status = 'error'
    },
    authLogout: (state) => {
        state.token = ''
    },
    setChangePassword: (state, val) => {
        state.isNeedChangePassword = val
    },
    setUsername: (state, val) => {
        state.username = val
    },
    setModerationSettings: (state, val) => {
        state.moderationSettings = val
    },
    setIsADUser: (state, val) => {
        state.isADUser = val
    },
};